<template>
  <div class="news-bg">
    <div class="news adaption">
      <div>
        <div class="headline himalaya">N<span>ews</span></div>
        <span class="title">新闻中心</span>
        <div class="br-line"></div>
      </div>
      <div @mouseout="active = index">
        <div
          v-for="(value, key) in tab"
          :key="key"
          class="tab"
          :class="active === key ? 'active' : ''"
          @mouseover="active = key"
          @click="tabClick(key)"
        >
          {{ value }}
        </div>
      </div>
      <div class="news-body">
        <div
          class="news-container"
          v-for="item in dataInfo[index]"
          :key="item"
          @click="open(item.newsInfoUrl)"
        >
          <div class="news-time num">
            {{ moment(item.publishTime).format("YYYY-MM-DD") }}
          </div>
          <div class="news-title">{{ item.title }}</div>
        </div>
        <div class="Wayra news-btn" @click="moreNews">更多新闻</div>
      </div>
    </div>
    <div class="bg"></div>
  </div>
</template>

<script>
import {newsApi} from "../../service/api/node";
import moment from "moment";

export default {
  name: "News",
  data() {
    return {
      index: "company",
      active: "company",
      tab: {
        company: "公司新闻",
        product: "产品动态",
        unscramble: "深度解读"
      },
      dataInfo: {
        company: [],
        product: [],
        unscramble: []
      },
      moment: moment
    };
  },
  created() {
    this.getData();
  },
  methods: {
    tabClick(key) {
      this.index = key;
      this.active = key;
    },
    open(url) {
      let urlString = document.domain;

      url && window.open("http://" + urlString + ":8080" + url);
    },
    moreNews() {
      let urlString = document.domain;

      window.open("http://" + urlString + ":8080" + "/node/36");
    },
    getData() {
      newsApi.list().then(res => {
        this.dataInfo.company = res.company;
        this.dataInfo.product = res.product;
        this.dataInfo.unscramble = res.unscramble;
        sessionStorage.setItem("dataInfo", JSON.stringify(res));
      });
    }
  }
};
</script>

<style scoped lang="less">
.news-bg {
  position: relative;
  background-color: #f4f8ff;
  height: 1310px;

  .bg {
    position: absolute;
    z-index: 1;
    top: 25px;
    left: 18%;
    width: 951px;
    height: 473px;
    background: url("../../assets/index/news/bg.png") center;
  }
}

.news {
  position: relative;
  z-index: 2;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  padding-top: 150px;

  .headline {
    width: 250px;
    height: 85px;
    font-size: 120px;
    color: #929ab9;

    span {
      font-size: 70px;
    }
  }

  .title {
    font-size: 36px;
    color: #232e55;
  }

  .br-line {
    width: 76px;
    margin-top: 10px;
    border-bottom: 2px solid #929ab9;
  }

  .tab {
    width: 120px;
    height: 55px;
    line-height: 55px;
    border-bottom: 1px solid #2851a5;
    text-align: center;
    cursor: pointer;

    &.active {
      transition: background 0.3s, font-size 0.3s;
      height: 90px;
      font-size: 17px;
      line-height: 90px;
      background: #2851a5;
      color: #ffffff;
    }
  }

  .news-body {
    flex: 1;
    margin-left: 35px;
    border-top: 1px solid #d2d8e3;

    .news-container {
      display: flex;
      align-content: flex-end;
      flex-direction: column;
      justify-content: center;
      height: 90px;
      border-bottom: 1px solid #d2d8e3;
      cursor: pointer;

      .news-time {
        font-size: 12px;
        color: #727272;
      }

      .news-title {
      }
    }

    .news-btn {
      width: 162px;
      margin-top: 50px;
      margin-bottom: 160px;
      font-size: 18px;
      text-align: center;
    }
  }
}
</style>
